// extracted by mini-css-extract-plugin
module.exports = {"render":"FLNAnalysis_render__2gAgE","currentPageButton":"FLNAnalysis_currentPageButton__agEFM","nextPageButton":"FLNAnalysis_nextPageButton__ft7u3"};